module.exports = __webpack_public_path__ + "img/floor_shadow.732a0701.png";